"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogIn = void 0;
var _react = require("react");
var _AuthProviderState = require("./AuthProviderState");
var _useReauthenticate = require("./useReauthenticate");
const useLogIn = (authImplementation, setAuthProviderState, getCurrentUser, skipFetchCurrentUser) => {
  const reauthenticate = (0, _useReauthenticate.useReauthenticate)(authImplementation, setAuthProviderState, getCurrentUser, skipFetchCurrentUser);
  return (0, _react.useCallback)(async options => {
    setAuthProviderState(_AuthProviderState.defaultAuthProviderState);
    const loginResult = await authImplementation.login(options);
    await reauthenticate();
    return loginResult;
  }, [authImplementation, reauthenticate, setAuthProviderState]);
};
exports.useLogIn = useLogIn;